<template>
  <v-layout row align-center class="nx-seo-field-group mb-5 pr-3">
    <v-flex xs3>
      <v-subheader>
        <span>{{ label }}</span>
        <v-btn flat icon small @click="showDialog = true">
          <v-icon>help_outline</v-icon>
        </v-btn>
      </v-subheader>
    </v-flex>
    <v-flex xs9>
      <div class="mt-3">
        <slot></slot>
      </div>
    </v-flex>

    <v-dialog v-model="showDialog"
              scrollable
              lazy
              max-width="600px">
      <v-card v-if="variables">
        <v-card-title class="headline">
          <div>
            <v-icon medium class="mr-2">info</v-icon>
            Variables
          </div>
        </v-card-title>
        <v-card-text>
            <v-data-table
                :items="variables"
                :headers="headers"
                :total-items="variables.length"
                :rows-per-apge-items="[-1]"
                hide-actions
            >
              <template v-slot:items="{ item }">
                <td>{{ item.variable }}</td>
                <td>{{ $t(`message.seo.variables.${item.label}`) }}</td>
              </template>
            </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'nx-seo-basic-field-group',
  props: {
    label: {
      type: String,
    },
  },
  data() {
    return {
      showDialog: false,
      headers: [{ text: 'Variable', sortable: false }, { text: 'Descripción', sortable: false }],
    };
  },
  computed: {
    ...mapState(['config']),
    variables() {
      if (!this.config || !this.config.seo || !this.config.seo.variables) {
        return [];
      }
      return this.config.seo.variables;
    },
  },
};
</script>

<style lang="stylus" scoped>
.nx-seo-field-group {
  border-left: 2px solid rgba(0, 0, 0, 0.54);
  background-color: #000000 05
}
</style>
